module.exports = __webpack_public_path__ + "img/head_img.5f72ced7.jpg";